import React from 'react';

import {SendIcon} from '../assets/icons';

import './ChatInputSection.css';

interface Props {
  input: string;
  loading: boolean;
  done: boolean;
  inputPlaceholder: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onSend: (type: 'text') => void;
}

export const ChatInputSection = ({input, loading, done, inputPlaceholder, onChange, onSend}: Props) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSend('text');
    }
  };

  const handleSendClick = () => onSend('text');

  const isSendDisabled = done || loading || !input.trim();

  return (
    <div className="chat-input-section">
      <textarea
        className="chat-input-section__textarea"
        placeholder={inputPlaceholder}
        value={input}
        rows={1}
        disabled={done || loading}
        onChange={onChange}
        onKeyDown={handleKeyDown}
      />
      <button className="chat-input-section__send" disabled={isSendDisabled} onClick={handleSendClick}>
        {loading ? (
          <span className="chat-input-section__spinner" />
        ) : (
          <SendIcon />
        )}
      </button>
    </div>
  );
};
